class TemplateBlogArticleJS {
    constructor() {
        // Custom code for blog/article page goes here
    }
}

typeof TemplateBlogArticleJS !== 'undefined' && new TemplateBlogArticleJS();

class articleSearch extends HTMLElement {
    constructor() {
      super();
       this.searchForm = document.querySelector('[data-articleSearchForm]');
       this.__domEventHandler();
    }
   
    __domEventHandler(){
        document.querySelector('[data-articleSearchForm]').addEventListener('submit' , e => {
            e.preventDefault();
            let searchStr = document.querySelector('input[data-articleSearch]').value;
            this._fetchArticle(searchStr)
        })
    }

     async _fetchArticle(articlestr){
        console.log('hiii',articlestr);
        if(articlestr.length > 1){
            let queryURL = `/search/suggest.json?q=${articlestr}&resources[type]=query,product,collection,page,article`;
            const response = await  fetch(queryURL, 
                { 
                        method: 'GET'
                })
    
                let data = await response.json();
                this._displayArticles(data.resources.results.articles)
        }
        else{
            document.querySelector('[data-articles]')?.classList.remove('d-none');
            document.querySelector('[data-pagination_bar]')?.classList.remove('d-none');
            document.querySelector('[data-searchedArticles]')?.classList.add('d-none');
        }
    }

    _displayArticles(articles){

        document.querySelector('[data-articles]')?.classList.add('d-none');
        document.querySelector('[data-pagination_bar]')?.classList.add('d-none');

        if(articles.length > 0){
            document.querySelector('[data-searchItem]').innerHTML = '';
            articles.forEach( article => {
                let cardHtml = `
                <div class="col-12 col-lg-4 col-md-4 col-sm-6  mb-md-5 mb-3 pb-md-0 pb-1 d-flex align-items-stretch justify-content-around">
                                  <div class="card card-product card-product-style-1 text-start rounded-0 border-0">
                                    <div class="card-img card-search-item ">
                                        <a href="${article.url}" title="Best Truck Seat Covers for Winter Weather">
                                              <img class="img-fluid" src="${article.featured_image.url }" loading="lazy" width="${article.featured_image.width}" height="${article.featured_image.height}" alt="${article.featured_image.alt}">
                                        </a>
                                    </div>
                                    <div class="card-body">
                                      <div class="row no-gutters">
                                          <div class="col-12">
                                            <h6 class="card-title mb-2 fw-semibold text-black h5 text-uppercase"><a class="text-decoration-none d-inline-block" href="${article.url}">${article.title}</a></h6>
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                `
                document.querySelector('[data-searchItem]').innerHTML += cardHtml;
            }); 
        }
        else{
            document.querySelector('[data-searchItem]').innerHTML = '<h5 class="text-uppercase">No Articles Found</h5>';
        }
        document.querySelector('[data-searchedArticles]')?.classList.remove('d-none');
    }

   }
   customElements.define('search-article', articleSearch);
